import { store } from '../../../store';
import { addProductsErrors } from './actions';

/**
 * Function de validation des commandes
 * @param  {object} values values du formulaire
 */
const validate = (values, props) => {
  const fullErrors = [];
  const errors = {};

  if (
    values.reference &&
    props.products.filter(
      product =>
        product.reference.toString().toLowerCase() ===
        values.reference.toString().toLowerCase()
    ).length > 1
  ) {
    errors.reference =
      'Référence déjà utilisée par un autre produit dans le fichier';
    fullErrors.push(
      'Référence déjà utilisée sur un autre produit dans le fichier'
    );
  }

  if (values.reference && props.barcodeValues) {
    if (
      props.barcodeValues.filter(
        product =>
          product.reference &&
          product.reference.toString().toLowerCase() ===
            values.reference.toString().toLowerCase()
      ).length > 0
    ) {
      errors.reference =
        'Référence déjà utilisée sur un autre produit dans le stock';
      fullErrors.push(
        'Référence déjà utilisée sur un autre produit dans le stock'
      );
    }
  }

  if (values.barcodeValue && props.products) {
    if (
      props.products.filter(
        product =>
          product.barcodeValue &&
          product.barcodeValue.toString().toLowerCase() ===
            values.barcodeValue.toString().toLowerCase()
      ).length > 1
    ) {
      errors.barcodeValue =
        'Code EAN13 déjà utilisée par un autre produit dans le fichier';
      fullErrors.push(
        'Code EAN13 déjà utilisée sur un autre produit dans le fichier'
      );
    }
  }

  if (values.barcodeValue && props.barcodeValues) {
    if (
      props.barcodeValues.filter(
        product =>
          product.barcodeValue &&
          product.barcodeValue.toString().toLowerCase() ===
            values.barcodeValue.toString().toLowerCase()
      ).length > 0
    ) {
      errors.barcodeValue =
        'Code EAN13 déjà utilisée sur un autre produit dans le stock';
      fullErrors.push(
        'Code EAN13 déjà utilisée sur un autre produit dans le stock'
      );
    }
  }

  if (values.insuranceRequired) {
    if (!values.value) {
      errors.value =
        'Valeur du produit obligatoire quand assurance est demandée';
      fullErrors.push(
        'Valeur du produit obligatoire quand assurance est demandée'
      );
    }
  }

  if (!values.name) {
    errors.value = 'Valeur du produit obligatoire quand assurance est demandée';
    fullErrors.push(
      'Valeur du produit obligatoire quand assurance est demandée'
    );
  }

  if (!values.barcodeValue) {
    errors.barcodeValue = 'Champs requis';
    fullErrors.push('Veuillez ajouter la code barre du produit');
  }

  if (values.barcodeValue && values.barcodeValue.length !== 13) {
    errors.barcodeValue = 'Code barre doit être de longeur 13';
    fullErrors.push('Code barre doit être de longeur 13');
  }

  if (!values.reference) {
    errors.reference = 'Champs requis';
    fullErrors.push('Veuillez ajouter la référence du produit');
  }

  store.dispatch(addProductsErrors({ fullErrors, index: props.index }));
  return errors;
};

export default validate;
